import { Component, OnInit } from "@angular/core";
import { Router, Event, NavigationEnd } from "@angular/router";
import { environment } from "src/environments/environment";
import { tokens } from "src/app/model/constants";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MixPanelTrackingService } from 'src/app/services/mixpanel-tracking.services';

declare let $: any;

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent implements OnInit {

    constructor(
        private http: HttpClient,
        private router: Router,
        private mixPanelTrackingService: MixPanelTrackingService
    ) {
        router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                $(".responsive-burger-menu").removeClass("active");
                $(".sidemenu-area").removeClass("active-sidemenu-area");
                if (event.url.includes('/daily-report-445')) {
                    setTimeout(() => {

                        const sidebar = document.querySelector(
                            '#sidebarMenu'
                        ) as HTMLElement;


                        if (sidebar) {

                            sidebar.scrollTop = sidebar.scrollHeight;

                            console.log(
                                'sidebar height:',
                                sidebar.scrollHeight
                            );

                        }

                    }, 100);
                }
            }
        });
    }

    sessionIdInfo: any;
    public menuSections = [];
    private order = [
        "SALES PERFORMANCE",
        "SHARE PERFORMANCE",
        "KBI PROGRESS REPORT",
        "PHOTO RECOGNITION REPORT",
        "LIMITED REPORT",
        "BLOG",
        "Chatbot"
    ];

    ngOnInit() {
        if (localStorage.getItem(tokens.accessToken) != null && localStorage.getItem("userinfo") != null) {
            let menu = localStorage.getItem('menu');
            if (menu == null) {
                this.getUser();
            }
            else {
                let res = JSON.parse(menu);
                this.menuSections = res.data[environment.menuSection];
                this.menuSections = this.menuSections.filter(x => x.name != 'EXECUTION TRACKING');
                this.sortMenu();
            }
        }
        else {
            this.router.navigateByUrl('authentication/login');
        }
    }

    public getUser() {
        let queryUrl = environment.hygraphGetMenus + "?url=" + location.pathname;
        let httpOptions: Object = {
            headers: new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('accessToken')),
            responseType: 'text'
        }
        this.http.get<any>(queryUrl, httpOptions)
            .subscribe(
                response => {
                    let res = JSON.parse(response);
                    localStorage.setItem('menu', response);
                    this.menuSections = res.data[environment.menuSection];
                    this.menuSections = this.menuSections.filter(x => x.name != 'EXECUTION TRACKING');
                    this.sortMenu();
                },
                error => {
                    console.log(error);
                }
            );
    }

    public sortMenu() {
        this.menuSections = this.menuSections.sort(
            (a, b) => {

                const indexA = this.order.indexOf(a.name);
                const indexB = this.order.indexOf(b.name);
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;

                return indexA - indexB;
            }
        );
    }

    ngOnDestroy() {
        // this.querySubscription.unsubscribe();
    }

    navigateToSenseVideo(sectionName: string) {
        this.mixPanelTrackingService.onTrackSenseVideoNavigate(sectionName, 'icon_click');
        const url = this.router.serializeUrl(
            this.router.createUrlTree(['/sensevideo'], { queryParams: { section: sectionName } })
        );
        const fullUrl = window.location.origin + url;
        const link = document.createElement('a');
        link.href = fullUrl;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

}
